// extracted by mini-css-extract-plugin
module.exports = {"title":"_3hnGk","content":"_2RIPk","button":"_1zRPX"};